(function() {
    'use strict';

    angular
        .module('PortalControllers')
        .directive('ttGridFilterTab', ttGridFilterTab);

    function ttGridFilterTab() {
        return {
            restrict: 'E',
            scope: {
                options: '=',
                labels: '='
            },
            //templateUrl: '/api/admin/portal/templates/customPortalFilter',
            templateUrl: 'common/portal/customPortalFilter',
            controller: ttGridFilterTabCtrl,
            link: ttGridFilterTabLink
        };

        function ttGridFilterTabLink (scope){
            scope.pristineState = angular.copy(scope.filterModel);
        }
    }

    function ttGridFilterTabCtrl($scope, lodash, $timeout) {
        this.$onInit = function() {

            $scope.filters = $scope.options.filters;
            var pageStartIndex = $scope.options.grid.pageStartIndex || 1;

            $scope.grid = angular.merge($scope.options.grid, {
                datasource: {
                    transport: {
                        parameterMap: function (data, type) {
                            if (type == 'read') {
                                var filter = angular.element('form').serializeArray();
                                if (filter.length > 0) {
                                    data.filter = filter.map(function (item) {
                                        return item.name + "=" + item.value;
                                    }).join('&');
                                }
                                data.page = data.page + pageStartIndex - 1 || pageStartIndex;
                                data.pageSize = data.pageSize || 10;
                            }
                            return data;
                        }
                    },
                    change: function () {
                        $scope.job_count = this.total();
                        $scope.$apply();
                    }
                }
            });

            if ($scope.filters) {
                $scope.appliedFilter = false;
                $scope.showFilter = true;
                $scope.filterModel = {};
                for (var i in $scope.filters) {
                    if ($scope.filters[i].type == 'dropdown') {
                        $scope.filterModel[$scope.filters[i].name] = [];
                    } else {
                        $scope.filterModel[$scope.filters[i].name] = {};
                    }

                }

                $scope.default = $scope.filters[Object.keys($scope.filters)[0]];
                $scope.active = null;

                $scope.toggleFilter = toggleFilter;
                $scope.clearFilter = clearFilter;
                $scope.isCheckbox = isCheckbox;
                $scope.isSelect =isSelect;
                $scope.isActive = isActive;
                $scope.activeCount = activeCount;
                $scope.filterClass = filterClass;
                $scope.setActive = setActive;
                $scope.getMultiselectOption = getMultiselectOption;
            }

            $scope.queryDb = queryDb;
            $scope.checkboxChanged = checkboxChanged;
            $scope.changeGrouping = changeGrouping;

            if (lodash.has($scope.options, 'groups')) {
                $scope.activeGroup = angular.copy(lodash.find($scope.options.groups, function (item) {
                    return (item.active) ? item : null;
                }));

                $scope.toggleGrouping = toggleGrouping;
                $scope.getActiveGroupClass = getActiveGroupClass;
                $scope.toggleGroupingClass = toggleGroupingClass;
                $scope.removeGroup = removeGroup;
            }

        }
        function toggleFilter() {
            $scope.showFilter = !$scope.showFilter;
        }

        function clearFilter() {
            $scope.filterModel = angular.copy($scope.pristineState);
            $scope.filterform.$setPristine();
            var timeoutPromise = $timeout(function () {
                $scope.jobsGrid.dataSource.page(1);
                $timeout.cancel(timeoutPromise);
            }, 250);
        }

        function isCheckbox(filter) {
            return filter.type == 'checkbox';
        }

        function isSelect(filter) {
            return filter.type == 'dropdown';
        }

        function isActive(filter) {
            var active = (function () {
                if ($scope.active == null) {
                    return filter.name == $scope.default.name;
                } else {
                    return filter.name == $scope.active.name;
                }
            })();

            return (active) ? "active" : '';
        }

        function activeCount() {
            var _filter = angular.element('form').serializeArray();
            var index = [];

            for (var i in _filter) {
                if (!(index.indexOf(_filter[i].name) >= 0)) {
                    index.push(_filter[i].name);
                }
            }

            return index.length;
        }

        function filterClass(filter) {
            var activeClass = $scope.isActive(filter);

            var _filter = angular.element('form').serializeArray();
            if (_filter.length > 0) {
                var res = lodash.find(_filter, function(item) {
                    return item.name.indexOf(filter.name) >= 0;
                });
            }

            if (res) {
                activeClass += ' selected';
            }

            return activeClass;
        }

        function setActive(filter) {
            $scope.active = filter;
        }

        function getMultiselectOption(filter) {
            return {
                dataSource: {
                    data: filter.data
                },
                dataTextField: 'label',
                dataValueField: 'value',
                change: function () {
                    $scope.jobsGrid.dataSource.read();
                }
            };
        }

        function queryDb() {
            var filter = angular.element('form').serialize();
            if (filter.length > 0) {
                $scope.jobsGrid.dataSource.query({filter: filter});
            } else {
                $scope.jobsGrid.dataSource.query();
            }
        }

        function checkboxChanged() {
            $scope.jobsGrid.dataSource.read();
        }

        function changeGrouping(field, dir) {
            var order = {
                field: field,
                dir: dir
            };
            $scope.jobsGrid.dataSource.group(order).page(1);
        }

        function toggleGrouping(group) {
            //group.dir =
            if ($scope.activeGroup == null) {
                $scope.activeGroup = angular.copy(group);
            } else {
                if ($scope.activeGroup.field == group.field) {
                    $scope.activeGroup.dir = ($scope.activeGroup.dir == 'asc') ? 'desc' : 'asc';
                } else {
                    $scope.activeGroup = angular.copy(group);
                }
            }

            $scope.jobsGrid.dataSource.group({
                field: $scope.activeGroup.field,
                dir: $scope.activeGroup.dir
            });
            $scope.jobsGrid.dataSource.page(1);
        }

        function getActiveGroupClass(group) {
            if (typeof $scope.activeGroup == typeof undefined) return "";
            if ($scope.activeGroup == null) return "";
            return (group.field == $scope.activeGroup.field) ? 'active' : "";
        }

        function toggleGroupingClass(group) {
            if (typeof $scope.activeGroup == typeof undefined) return "";
            if ($scope.activeGroup == null) return "";
            if (group.field == $scope.activeGroup.field) {
                return ($scope.activeGroup.dir == 'asc') ? "fa-arrow-up" : "fa-arrow-down";
            }
            return "";
        }

        function removeGroup($event) {
            $event.stopPropagation();
            $scope.activeGroup = null;
            $scope.jobsGrid.dataSource.group([]);
            $scope.jobsGrid.dataSource.page(1);
        }
    }
})();